

export const baseURL = "https://realistic-car-8426bb2aec.strapiapp.com";